import React, { useEffect } from "react";
import QualityMetricsView from "./QualityMetricsView";
import { useQuality } from "./common/QualityContext"; // Adjust the path if needed

/**
 * Container component for QualityMetricsView
 * Uses context to get metrics data and logs it
 */
const QualityMetricsContainer = () => {
  const { data, loading, error } = useQuality();

  useEffect(() => {
    if (data) {
      console.log("Quality metrics data:", data);
    }
  }, [data]);

  // While loading, render nothing. Once loading is false and data is available, the component will re-render and display the view.
  if (loading) return null;
  // If there's an error, log it but do not disrupt the view.
  if (error) return <div></div>;
  if (!data) return null;

  return <QualityMetricsView metricsData={data} title="Quality Metrics" />;
};

export default QualityMetricsContainer;



// WEBPACK FOOTER //
// ./src/components/quality/QualityMetricsContainer.js